import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "sonner";
import { Trash2, Mail, Phone, ChevronDown } from "lucide-react";
import { api } from "@/lib/api";

const statuses = ["Nuovo", "Contattato", "Chiuso"];
const kindLabels = { valutazione: "Valutazione casa", condominio: "Preventivo condominio", contatto: "Contatto" };

export default function AdminLeads() {
  const qc = useQueryClient();
  const [filter, setFilter] = useState("");
  const [expanded, setExpanded] = useState(null);
  const { data: leads = [] } = useQuery({ queryKey: ["admin-leads"], queryFn: async () => (await api.get("/admin/leads")).data });

  const filtered = filter ? leads.filter((l) => l.kind === filter) : leads;

  const setStatus = async (id, status) => {
    await api.put(`/admin/leads/${id}`, { status });
    qc.invalidateQueries({ queryKey: ["admin-leads"] });
    qc.invalidateQueries({ queryKey: ["stats"] });
    toast.success("Stato aggiornato");
  };
  const remove = async (id) => {
    if (!window.confirm("Eliminare questa richiesta?")) return;
    await api.delete(`/admin/leads/${id}`);
    qc.invalidateQueries({ queryKey: ["admin-leads"] });
    toast.success("Richiesta eliminata");
  };

  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-[#1B2A41]">Richieste & Lead</h1>
      <div className="flex gap-2 mt-6 flex-wrap">
        <button onClick={() => setFilter("")} className={`px-4 py-2 rounded-full text-sm font-medium ${!filter ? "bg-[#1B2A41] text-white" : "bg-white border border-[#DCE6EF]"}`} data-testid="lead-filter-all">Tutte ({leads.length})</button>
        {Object.entries(kindLabels).map(([k, l]) => (
          <button key={k} onClick={() => setFilter(k)} className={`px-4 py-2 rounded-full text-sm font-medium ${filter === k ? "bg-[#1B2A41] text-white" : "bg-white border border-[#DCE6EF]"}`} data-testid={`lead-filter-${k}`}>{l} ({leads.filter((x) => x.kind === k).length})</button>
        ))}
      </div>

      <div className="mt-6 space-y-3">
        {filtered.length ? filtered.map((l) => (
          <div key={l.id} className="bg-white rounded-2xl border border-[#DCE6EF] overflow-hidden" data-testid={`lead-row-${l.id}`}>
            <div className="p-5 flex flex-col sm:flex-row sm:items-center gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-semibold text-[#1B2A41]">{l.name}</span>
                  <span className="text-xs font-mono bg-[#E3ECF3] text-[#566476] px-2 py-0.5 rounded-full">{kindLabels[l.kind] || l.kind}</span>
                  <span className="text-xs text-[#8695A6]">{new Date(l.created_at).toLocaleString("it-IT")}</span>
                </div>
                <div className="flex gap-4 mt-2 text-sm text-[#566476] flex-wrap">
                  <a href={`mailto:${l.email}`} className="flex items-center gap-1 hover:text-[#2472C8]"><Mail className="w-4 h-4" />{l.email}</a>
                  <a href={`tel:${l.phone}`} className="flex items-center gap-1 hover:text-[#2472C8]"><Phone className="w-4 h-4" />{l.phone}</a>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <select value={l.status} onChange={(e) => setStatus(l.id, e.target.value)} className="px-3 py-2 rounded-lg border border-[#DCE6EF] text-sm bg-white" data-testid={`lead-status-${l.id}`}>
                  {statuses.map((s) => <option key={s}>{s}</option>)}
                </select>
                <button onClick={() => setExpanded(expanded === l.id ? null : l.id)} className="p-2 rounded-lg border border-[#DCE6EF] text-[#566476]" data-testid={`lead-expand-${l.id}`}><ChevronDown className={`w-4 h-4 transition-transform ${expanded === l.id ? "rotate-180" : ""}`} /></button>
                <button onClick={() => remove(l.id)} className="p-2 rounded-lg border border-[#DCE6EF] text-[#7A1F1F] hover:bg-red-50" data-testid={`lead-delete-${l.id}`}><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
            {expanded === l.id && (
              <div className="px-5 pb-5 border-t border-[#EAF0F6] pt-4 text-sm">
                {l.message && <p className="text-[#2C3A4F] mb-3"><strong>Messaggio:</strong> {l.message}</p>}
                {l.data && Object.keys(l.data).length > 0 && (
                  <div className="grid sm:grid-cols-2 gap-2">
                    {Object.entries(l.data).map(([k, v]) => v ? <div key={k} className="bg-[#EEF4F9] rounded-lg px-3 py-2"><span className="text-[#8695A6] capitalize">{k.replace(/_/g, " ")}:</span> <span className="text-[#1B2A41] font-medium">{String(v)}</span></div> : null)}
                  </div>
                )}
              </div>
            )}
          </div>
        )) : <div className="bg-white rounded-2xl border border-dashed border-[#CBD7E2] p-12 text-center text-[#8695A6]">Nessuna richiesta in questa categoria.</div>}
      </div>
    </div>
  );
}
